"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Load locales for datejs
require("dayjs/locale/zh-cn");
require("dayjs/locale/ar");
require("dayjs/locale/fr");
require("dayjs/locale/pl");
require("dayjs/locale/de");
require("dayjs/locale/pt");
require("dayjs/locale/sl");
require("dayjs/locale/es");
require("dayjs/locale/nl");
require("dayjs/locale/it");
require("dayjs/locale/lt");
require("dayjs/locale/ja");
require("dayjs/locale/tlh");
require("dayjs/locale/sk");
require("dayjs/locale/fi");
require("dayjs/locale/da");
require("dayjs/locale/tr");
require("dayjs/locale/nb");
require("dayjs/locale/cs");
require("dayjs/locale/is");
require("dayjs/locale/ru");
require("dayjs/locale/ko");
require("dayjs/locale/sv");
require("dayjs/locale/en-gb");
require("dayjs/locale/en");
require("dayjs/locale/lv");
